export const pastDeliveriesPolicies = {
    primitivePastDeliveries: {
        read(_, { readField }) {
            const deliveriesRefs = readField('deliveries');
            return deliveriesRefs.map(({ __ref }) => __ref);
        },
    },
};
